/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_EcosystemInputs */

const en_mk_cmp_r_ecosystem = /** @type {(inputs: Mk_Cmp_R_EcosystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecosystem & integrations`)
};

const id_mk_cmp_r_ecosystem = /** @type {(inputs: Mk_Cmp_R_EcosystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekosistem & integrasi`)
};

/**
* | output |
* | --- |
* | "Ecosystem & integrations" |
*
* @param {Mk_Cmp_R_EcosystemInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_ecosystem = /** @type {((inputs?: Mk_Cmp_R_EcosystemInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_EcosystemInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_ecosystem(inputs)
	return en_mk_cmp_r_ecosystem(inputs)
});